<template>
    <!-- Próxima página de contatos a caminho. Fica no FIM da lista, onde o scroll
         infinito pediu a página — um spinner no cabeçalho estaria fora da tela. -->
    <li class="contact-search-loading d-flex align-items-center justify-content-center gap-2" :class="{ 'anima-saida': saindo }">
        <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
        <span class="text-muted font-size-12">Carregando mais contatos...</span>
    </li>
</template>

<script setup lang="ts">
defineProps({
    saindo: { type: Boolean, default: false },
});
</script>

<style scoped>
.contact-search-loading {
    list-style: none;
    height: 44px;
    animation: carregando-entra 0.2s ease-out both;
}
.anima-saida { animation: carregando-sai 0.18s ease-in forwards; }
@keyframes carregando-entra { from { opacity: 0; } to { opacity: 1; } }
@keyframes carregando-sai { from { opacity: 1; } to { opacity: 0; } }
</style>
